import React, { useState, useEffect } from 'react';
import {
  Container,
  Card,
  Table,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
  Spinner,
  Alert,
  Pagination,
  Modal,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaSearch, FaPlus, FaEdit, FaTrash, FaTimes, FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import * as api from '~/Services/Service';
import ModalFornecedor from './components/ModalFornecedor';
import SecaoContasVinculadas from './components/SecaoContasVinculadas';
import './styles.css';

var ITENS_POR_PAGINA = 20;

var linkStyle = { cursor: 'pointer', color: '#0747a6', textDecoration: 'underline', fontWeight: 'bold' };

const CadastroUnicoFornecedor = () => {
  const [fornecedores, setFornecedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [pagina, setPagina] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [fornecedorDetalhe, setFornecedorDetalhe] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [fornecedorParaExcluir, setFornecedorParaExcluir] = useState(null);
  const [loadingAcao, setLoadingAcao] = useState(false);
  const [showModalContas, setShowModalContas] = useState(false);
  const [fornecedorContas, setFornecedorContas] = useState(null);
  const [ordenacao, setOrdenacao] = useState({ campo: 'codigo', direcao: 'asc' });

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  useEffect(() => {
    carregarFornecedores();
  }, []);

  const carregarFornecedores = async () => {
    setLoading(true);
    try {
      const res = await api.listarCadUnicoFornecedores();
      setFornecedores(res || []);
    } catch (e) {
      toast.error('Erro ao carregar fornecedores');
    } finally {
      setLoading(false);
    }
  };

  const fornecedoresFiltrados = (fornecedores || []).filter(function (f) {
    if (!busca) return true;
    var b = busca.toLowerCase();
    return (
      (f.apelido && f.apelido.toLowerCase().indexOf(b) >= 0) ||
      (f.razao_social && f.razao_social.toLowerCase().indexOf(b) >= 0) ||
      (f.cpf && f.cpf.toLowerCase().indexOf(b) >= 0)
    );
  });

  var fornecedoresOrdenados = fornecedoresFiltrados.slice().sort(function (a, b) {
    var campo = ordenacao.campo;
    var dir = ordenacao.direcao === 'asc' ? 1 : -1;
    var valA = a[campo];
    var valB = b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (campo === 'codigo' || campo === 'total_contas') return dir * (Number(valA) - Number(valB));
    return dir * String(valA).toLowerCase().localeCompare(String(valB).toLowerCase());
  });

  var totalPaginas = Math.ceil(fornecedoresOrdenados.length / ITENS_POR_PAGINA) || 1;
  var dadosPaginados = fornecedoresOrdenados.slice((pagina - 1) * ITENS_POR_PAGINA, pagina * ITENS_POR_PAGINA);

  var renderizarPaginacao = function () {
    if (totalPaginas <= 1) return null;
    var itens = [];
    var maxBotoes = 5;

    itens.push(
      <Pagination.First key="first" onClick={function () { setPagina(1); }} disabled={pagina === 1} />
    );
    itens.push(
      <Pagination.Prev key="prev" onClick={function () { setPagina(pagina - 1); }} disabled={pagina === 1} />
    );

    var inicioPaginas = Math.max(1, pagina - Math.floor(maxBotoes / 2));
    var fimPaginas = Math.min(totalPaginas, inicioPaginas + maxBotoes - 1);
    if (fimPaginas - inicioPaginas < maxBotoes - 1) {
      inicioPaginas = Math.max(1, fimPaginas - maxBotoes + 1);
    }

    if (inicioPaginas > 1) {
      itens.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
    }

    var numeros = [];
    for (var i = inicioPaginas; i <= fimPaginas; i++) { numeros.push(i); }
    numeros.forEach(function (num) {
      itens.push(
        <Pagination.Item key={num} active={num === pagina} onClick={function () { setPagina(num); }}>
          {num}
        </Pagination.Item>
      );
    });

    if (fimPaginas < totalPaginas) {
      itens.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    itens.push(
      <Pagination.Next key="next" onClick={function () { setPagina(pagina + 1); }} disabled={pagina === totalPaginas} />
    );
    itens.push(
      <Pagination.Last key="last" onClick={function () { setPagina(totalPaginas); }} disabled={pagina === totalPaginas} />
    );

    return (
      <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ borderTop: '1px solid #dee2e6' }}>
        <small className="text-muted">
          Mostrando {dadosPaginados.length > 0 ? (pagina - 1) * ITENS_POR_PAGINA + 1 : 0}
          {' até '}{Math.min(pagina * ITENS_POR_PAGINA, fornecedoresFiltrados.length)}{' de '}{fornecedoresFiltrados.length}{' registros'}
        </small>
        <Pagination className="mb-0">{itens}</Pagination>
      </div>
    );
  };

  const handleAbrirContas = function (fornecedor) {
    setFornecedorContas(fornecedor);
    setShowModalContas(true);
  };

  const handleNovoClick = () => {
    setFornecedorDetalhe(null);
    setModoEdicao(false);
    setShowModal(true);
  };

  const handleEditarClick = async (e, fornecedor) => {
    e.stopPropagation();
    setLoadingAcao(true);
    try {
      const detalhe = await api.obterCadUnicoFornecedor(fornecedor.codigo);
      detalhe.total_contas = fornecedor.total_contas || 0;
      setFornecedorDetalhe(detalhe);
      setModoEdicao(true);
      setShowModal(true);
    } catch (err) {
      toast.error('Erro ao carregar dados do fornecedor');
    } finally {
      setLoadingAcao(false);
    }
  };

  const handleExcluirClick = (e, fornecedor) => {
    e.stopPropagation();
    setFornecedorParaExcluir(fornecedor);
    setShowConfirmDelete(true);
  };

  const handleConfirmarExclusao = async () => {
    if (!fornecedorParaExcluir) return;
    setLoadingAcao(true);
    try {
      await api.excluirCadUnicoFornecedor(fornecedorParaExcluir.codigo);
      toast.success('Fornecedor excluído com sucesso!');
      setShowConfirmDelete(false);
      setFornecedorParaExcluir(null);
      carregarFornecedores();
    } catch (err) {
      const msg =
        (err && err.response && err.response.data && err.response.data.message) ||
        'Erro ao excluir fornecedor';
      toast.error(msg);
    } finally {
      setLoadingAcao(false);
    }
  };

  const handleSalvo = () => {
    setShowModal(false);
    carregarFornecedores();
  };

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Cadastro Único de Fornecedores" />

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Row className="align-items-end">
            <Col xs={12} md={5}>
              <Form.Group controlId="filtro.busca" className="mb-md-0 mb-2">
                <Form.Label>Busca</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text><FaSearch /></InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    placeholder="Apelido, razão social ou CNPJ..."
                    value={busca}
                    onChange={function (e) { setBusca(e.target.value); setPagina(1); }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} md={7}>
              <Form.Group className="d-flex justify-content-end flex-wrap mb-0" style={{ gap: '8px' }}>
                {busca && (
                  <Button variant="outline-secondary" onClick={function () { setBusca(''); setPagina(1); }}>
                    <FaTimes className="mr-1" /> Limpar
                  </Button>
                )}
                <Button variant="success" onClick={handleNovoClick}>
                  <FaPlus className="mr-1" /> Novo Fornecedor
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm mb-3">
        <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }} className="py-2">
          <strong>
            Fornecedores
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({fornecedoresFiltrados.length}{' '}
              {fornecedoresFiltrados.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" size="sm" />
              <span className="ml-2">Carregando...</span>
            </div>
          ) : fornecedoresFiltrados.length === 0 ? (
            <p className="text-muted text-center my-4">Nenhum fornecedor encontrado.</p>
          ) : (
            <>
              <div style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                    <tr>
                      <th style={Object.assign({ width: 60 }, thSortStyle)} onClick={function () { handleOrdenacao('codigo'); }}>Cód.{iconeOrdenacao('codigo')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('apelido'); }}>Apelido{iconeOrdenacao('apelido')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('razao_social'); }}>Razão Social{iconeOrdenacao('razao_social')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('cpf'); }}>CNPJ/CPF{iconeOrdenacao('cpf')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('cidade'); }}>Cidade/UF{iconeOrdenacao('cidade')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('fone_1'); }}>Fone{iconeOrdenacao('fone_1')}</th>
                      <th style={Object.assign({ width: 70, textAlign: 'center' }, thSortStyle)} onClick={function () { handleOrdenacao('total_contas'); }}>Contas{iconeOrdenacao('total_contas')}</th>
                      <th style={{ width: 90, textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosPaginados.map(function (f) {
                      return (
                        <tr key={f.codigo}>
                          <td>{f.codigo}</td>
                          <td>{f.apelido}</td>
                          <td>{f.razao_social}</td>
                          <td>{f.cpf || '-'}</td>
                          <td>{f.cidade ? f.cidade + '/' + (f.estado || '') : '-'}</td>
                          <td>{f.fone_1 || '-'}</td>
                          <td className="text-center">
                            <span
                              style={linkStyle}
                              onClick={function () { handleAbrirContas(f); }}
                            >
                              {f.total_contas != null ? f.total_contas : 0}
                            </span>
                          </td>
                          <td className="text-center cuf-table-actions">
                            <Button
                              size="sm"
                              variant="outline-primary"
                              className="mr-1"
                              title="Editar"
                              disabled={loadingAcao}
                              onClick={function (e) { handleEditarClick(e, f); }}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir"
                              disabled={loadingAcao}
                              onClick={function (e) { handleExcluirClick(e, f); }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              {renderizarPaginacao()}
            </>
          )}
        </Card.Body>
      </Card>

      <Modal
        show={showModalContas}
        onHide={function () { setShowModalContas(false); setFornecedorContas(null); }}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
            Contas Vinculadas{fornecedorContas ? ' — ' + fornecedorContas.apelido : ''}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SecaoContasVinculadas
            codigoCadastro={fornecedorContas ? fornecedorContas.codigo : null}
            onContaCriada={carregarFornecedores}
          />
        </Modal.Body>
      </Modal>

      <ModalFornecedor
        show={showModal}
        onHide={() => setShowModal(false)}
        onSalvar={handleSalvo}
        fornecedor={fornecedorDetalhe}
        modoEdicao={modoEdicao}
      />

      {showConfirmDelete && fornecedorParaExcluir != null && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1050,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={e => {
            if (e.target === e.currentTarget) setShowConfirmDelete(false);
          }}
        >
          <Card style={{ maxWidth: 440, width: '90%' }}>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <strong>Confirmar Exclusão</strong>
              <Button
                variant="link"
                size="sm"
                className="p-0"
                onClick={() => setShowConfirmDelete(false)}
              >
                ✕
              </Button>
            </Card.Header>
            <Card.Body>
              {fornecedorParaExcluir.total_contas > 0 ? (
                <Alert variant="danger" className="mb-0">
                  Não é possível excluir. Existem{' '}
                  <strong>{fornecedorParaExcluir.total_contas}</strong> conta(s) vinculada(s) a
                  este cadastro.
                </Alert>
              ) : (
                <p className="mb-0">
                  Tem certeza que deseja excluir o fornecedor{' '}
                  <strong>{fornecedorParaExcluir.apelido}</strong>?
                </p>
              )}
            </Card.Body>
            <Card.Footer className="text-right">
              <Button
                variant="secondary"
                size="sm"
                className="mr-2"
                onClick={() => setShowConfirmDelete(false)}
              >
                {fornecedorParaExcluir.total_contas > 0 ? 'Fechar' : 'Cancelar'}
              </Button>
              {fornecedorParaExcluir.total_contas === 0 && (
                <Button
                  variant="danger"
                  size="sm"
                  disabled={loadingAcao}
                  onClick={handleConfirmarExclusao}
                >
                  {loadingAcao ? <Spinner animation="border" size="sm" /> : 'Excluir'}
                </Button>
              )}
            </Card.Footer>
          </Card>
        </div>
      )}
    </Container>
  );
};

export default CadastroUnicoFornecedor;
